import React from 'react';
import '../static/css/about.css';

const About = () => (
  <div
    className="about-container"
  >
    <p>
      Whether it's a concert, a ball game or a play, it should never cost
      thousands of dollars to have a good time.
      <br />
      <br />
      Here at MoshPit, we're all about bringing people together and keeping
      <br />
      costs low for venues and customers.
    </p>
  </div>
);

export default About;
